<template>
  <div id="main-content" class="add-pickup-route">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <form>
        <el-row>
          <el-col :span="12" style="display: inline">
            <el-col :span="8">
              <span class="required-star">* </span><span class="form-lable">{{ $t('common.pickup_route_name') }}</span>
            </el-col>
            <input class="input" v-model="pickup_route_info.name" type=""/>
            <el-col v-if="error_message.name" :offset="8" :span="16">
              <span v-for="(value, key) in error_message.name" :key="key" class="form-error"> {{ value }}</span>
            </el-col>
          </el-col>
          <el-col :span="12" style="display: inline">
            <el-col :span="8">
              <span class="form-lable">{{ $t('common.bus') }}</span>
            </el-col>
            <el-select  v-model="pickup_route_info.bus_info.id" collapse-tags
                        style="width: 60%;float: left;margin: 0 !important;" placeholder="Bus">
              <el-option
                v-for="bus in filteredBusList"
                :key="bus.id"
                :label="`${bus.name}, ${bus.license_plate}`"
                :value="bus.id">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col :span="24" style="display: inline">
            <el-col :span="4">
              <span class="form-lable">{{ $t('common.member') }}</span>
            </el-col>
            <el-select  v-model="parentIds" multiple collapse-tags
                        style="width: 60%;float: left;margin: 0 !important;" :placeholder="$t('common.please_select')">
              <el-option
                  v-for="parent in parentList"
                  v-show="parent.is_member == 1"
                  :key="parent.id"
                  :label="parent.name"
                  :value="parent.id">
                {{ getParentLabel(parent) }}
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row class="row-section">
          <h3>{{ $t('bus_stop.bus_stop_list') }}</h3>
        </el-row>
        <el-row class="row-section">
          <el-button @click="addPlace()" style="float: left; margin-left: 20px" type="success" icon="el-icon-plus" circle></el-button>
          <span style="line-height: 40px;margin-left: 20px;">{{ $t('bus_stop.add_bus_stop') }}</span>
        </el-row>
        <div v-for="(item, index) in pickup_route_info.place_list" :key="index">
          <el-row style="padding-bottom: 20px">
            <el-col :span="18" style="display: inline">
              <div style="display: none" v-if="pickup_route_info.place_list[index].id != '-1'">{{ select_model = pickup_route_info.place_list[index].id +'|'+index }}</div>
              <div style="display: none" v-else>{{ select_model = '-1|'+index }}</div>
              <el-col :span="8">
                <span style="width: 25%" class="form-lable">{{ $t('common.bus_stop') }} {{ index+1 }}</span>
              </el-col>
              <select style="width: 30%; float: left" @change="didSelectPlace" v-model="select_model" class="input">
                <option :value="'-1|'+index">{{ $t('common.please_select') }}</option>
                <option v-for="place in sortedPlaceList" :disabled="selected.includes(place.id.toString())" v-bind:key="place.id" :value="place.id+'|'+index">
                  {{ place.name }}
                </option>
              </select>
              <el-button @click="removePlace(index)" style="float: left; margin-left: 20px" type="danger" icon="el-icon-minus" circle></el-button>
              <el-col v-if="error_message.place_list[index].id" :offset="8" :span="16">
                <span v-for="(value, key) in error_message.place_list[index].id" :key="key" class="form-error"> {{ value }}</span>
              </el-col>
            </el-col>
          </el-row>
        </div>
        <el-row style="padding-top: 50px">
          <el-button style="font-size: 20px; width: 30%" type="success" @click="submitAction">{{ $t('common.submit') }}</el-button>
        </el-row>
      </form>
    </el-col>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import PageTitle from '@/components/PageTitle'

  export default {
    name: "AddPickupRoute",
    components: {
      PageTitle
    },
    data: function () {
      return {
        backLink: `/pickup-route?action=back`,
        title: 'route.add_pickup_route',
        pickup_route_info: {
          name: "",
          place_list: [ {id:"-1"}, {id:"-1"} ],
          bus_info: {
            id: ''
          },
          parent_info: {
            id: null
          },
        },
        selected: [],
        error_message: {
          name: [],
          place_list: [ {id: [], isError: false}, {id: [], isError: false} ],
        },
        parentList: [],
        parentIds: []
      }
    },
    methods: {
      submitAction: function () {
        let check = this.validate()
        if (check) {
          let successCallback = () => {
            this.$router.push('/pickup-route')
          };
          var pickup_route_copy = this.pickup_route_info
          for (const [key, value] of Object.entries(pickup_route_copy.place_list)) {
            var placeData = value.id.split('|')
            pickup_route_copy.place_list[key].id = placeData[0]
          }
          let payload = {
            successCallback,
            data: {
              ...pickup_route_copy,
              parent_ids: this.parentIds
            }
          }
          this.$store.dispatch('pickuproute/createPickupRoute', payload);
        } else {
          this.$store.commit('openNotification', {
            type: 'error',
            message: this.$t('common.please_check_input_error')
          })
          return false
        }
      },
      validate: function () {
        var check = true
        this.error_message.name = []
        if (this.pickup_route_info.name === "") {
          this.error_message.name.push('* ' + this.$t('common.route_name_is_required'))
          check = false
        }

        if (this.pickup_route_info.place_list.length) {
          for (const [key, value] of Object.entries(this.pickup_route_info.place_list)) {
            if (!this.validateList(key, value)) check = false
          }
        }

        return check
      },
      validateList(index, value) {
        var check = true
        this.error_message.place_list[index].id = []
        if (value.id === "-1") {
          check = false
          this.error_message.place_list[index].id.push('* ' + this.$t('route.please_select_bus_stop'))
        }
        if (index == 0) {
          if (value.id != "-1" && !this.placeList[this.placeList.findIndex(x => x.id == value.id)].is_parking) {
            this.error_message.place_list[index].id.push('* ' + this.$t('route.first_bus_stop_must_be_parking_lot'))
          }
        }

        if (index == this.error_message.place_list.length - 1) {
          if (value.id != "-1" && !this.placeList[this.placeList.findIndex(x => x.id == value.id)].is_school) {
            this.error_message.place_list[index].id.push('* ' + this.$t('route.last_bus_stop_must_be_school'))
          }
        }

        this.error_message.place_list[index].isError = !check
        return check
      },
      addPlace: function () {
        this.error_message.place_list.push({id: [], isError: false})
        this.pickup_route_info.place_list.push({id:"-1"})
      },
      removePlace(index) {
        let oldId = this.pickup_route_info.place_list[index].id
        let oldIndex = this.selected.indexOf(oldId)

        if (oldIndex !== -1) {
          this.selected.splice(oldIndex, 1)
        }

        this.pickup_route_info.place_list.splice(index, 1)
        this.error_message.place_list.splice(index, 1)
      },
      didSelectPlace: function (e) {
        let selectData = e.target.value.split('|')
        let oldId = this.pickup_route_info.place_list[selectData[1]].id
        let oldIndex = this.selected.indexOf(oldId)

        if (oldIndex !== -1) {
          this.selected.splice(oldIndex, 1)
        }

        this.pickup_route_info.place_list[selectData[1]].id = selectData[0]

        this.selected.push(selectData[0])
      },
      getParentLabel (parent) {
        let label = []

        if (parent.name && parent.name.trim()) {
          label.push(parent.name.trim())
        }

        if (parent.furigana && parent.furigana.trim()) {
          label.push(parent.furigana.trim())
        }

        if (parent.email && parent.email.trim()) {
          label.push(parent.email.trim())
        }

        return label.join(' - ')
      }
    },
    mounted: function () {
      this.$store.dispatch('place/retrievePlaceList', {})
      this.$store.dispatch('bus/retrieveBusList', {})
      this.$store.dispatch('pickuproute/retrievePickupRouteList', {})

      let payload = {
        successCallback: (response) => {
          this.parentList = [].concat(response.data.data.parent_list)
        }
      }

      this.$store.dispatch('parent/retrieveParentList', payload)
    },
    computed: {
      ...mapState('place', ['placeList']),
      ...mapState('bus', ['busList']),
      ...mapState('pickuproute', ['pickupRouteList']),
      sortedPlaceList: function () {
        let sortedPlaceList = [].concat(this.placeList)

        sortedPlaceList.sort((before, after) => {
          return before.name < after.name ? -1 : before.name > after.name ? 1 : 0
        })

        return sortedPlaceList
      },
      filteredBusList: function () {
        let existBusIds = []

        this.pickupRouteList.forEach((pickupItem) => {
          if (pickupItem.bus_info) {
            existBusIds.push(pickupItem.bus_info.id)
          }
        })

        return this.busList.filter((busItem) => {
          return existBusIds.indexOf(busItem.id) === -1
        })
      }
    }
  }
</script>

<style lang="scss">

</style>